function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M21 2V14.1C21 16 20 17 18.1 17H5.89999C3.99999 17 3 16 3 14.1V2H21Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H22C22.41 1.25 22.75 1.59 22.75 2C22.75 2.41 22.41 2.75 22 2.75Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.6703 22.34C16.5403 22.6 16.2703 22.75 16.0003 22.75C15.8903 22.75 15.7703 22.72 15.6703 22.67L12.0003 20.84L8.33025 22.67C8.23025 22.72 8.11027 22.75 8.00027 22.75C7.73027 22.75 7.46025 22.6 7.33025 22.34C7.14025 21.96 7.29028 21.51 7.67028 21.33L11.2503 19.54V17H12.7503V19.54L16.3303 21.33C16.7103 21.51 16.8603 21.96 16.6703 22.34Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.5009 11.75C7.2909 11.75 7.07092 11.66 6.92092 11.48C6.65092 11.16 6.70089 10.69 7.02089 10.42L10.1709 7.79C10.4609 7.55 10.8309 7.45 11.1809 7.51C11.5409 7.57 11.8509 7.78997 12.0409 8.10997L13.0909 9.85997L16.0209 7.42C16.3409 7.15 16.8109 7.19998 17.0809 7.51998C17.3509 7.83998 17.3009 8.30997 16.9809 8.57997L13.8309 11.21C13.5409 11.45 13.1709 11.55 12.8209 11.49C12.4609 11.43 12.1509 11.21 11.9609 10.89L10.9109 9.14L7.98091 11.58C7.84091 11.69 7.6709 11.75 7.5009 11.75Z",
  fill: "white",
  fillOpacity: 0.4
});

var SvgPhantichDark = function SvgPhantichDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhantichDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phantich_dark.c8c4d60d.svg";
export { ForwardRef as ReactComponent };